<template>
<div class="profile-invitations-list">
    <h1 v-if="allInvitations.length">{{ t.invitations }}</h1>
    <div class="invitation" v-for="invitation in allInvitations" :key="invitation.id">
        <h3>
            <a :href="invitation.event.url">{{ invitation.event.title }}</a>
        </h3>
        <button class="btn btn-success" @click="respond(invitation, 'update')">{{ gt.common.accept }}</button>
        <button class="btn btn-danger" @click="respond(invitation, 'delete')">{{ gt.common.decline }}</button>
    </div>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import { mapState } from 'vuex';

export default {
    name: 'ProfileEventInvites',
    computed: mapState(['gt', 'siteConfig']),
    data() {
        return {
            allInvitations: this.invitations
        };
    },
    methods: {
        respond(invitation, method) {
            const url = this.siteConfig.endpoints.eventInvite.replace(0, invitation.event.id);
            ajax[method](url, {
                id: invitation.id
            }).then((response) => {
                this.allInvitations = this.allInvitations.filter(checkInvite => checkInvite.id !== invitation.id);
                this.$store.dispatch('notify', { msg: response.message });
            });
        }
    },
    props: {
        invitations: {
            type: Array
        },
        t: {
            type: Object
        }
    }
};

</script>
